import React from "react";
import SettingsOverview from "../../Components/Settings/SettingOverview/SettingsOverview.jsx";
import NewSettingsOverview from "../../Components/Settings/SettingOverview/NewSettingsOverview.jsx";

export default function SettingsPage(props) {
  return (
    <div>
      {/* <SettingsOverview params={props.match.params} /> */}
      <NewSettingsOverview params={props.match.params} />
    </div>
  );
}
